import React from "react";
import PropTypes from "prop-types";
import { withStore, withScreenCheck } from "../hoc";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Body from "../components/Body";
import Footer from "../components/Footer";

import {
  Card,
  CardAccordion,
  CardChroniqueHome as CardChronique,
  CardContact,
} from "../components/Cards";

/**
 * Home
 */
class Home extends React.Component {
  static displayName = "Home";
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @override
   */
  render() {
    const chroniquePage = this.props.stores.page.pages.ChroniquePage.first();
    const lastChronique = chroniquePage.chroniques().first();
    const links = this.props.currentPage.links();
    const slideshowImages = this.props.currentPage.slideshowImages();
    const slideshowMobileImages = this.props.currentPage.slideshowMobileImages();
    return (
      <div className="Home">
        <Navbar {...this.props} isHome={true} />
        <Header
          {...this.props}
          images={
            this.props.screen === "desktop"
              ? slideshowImages.toJS()
              : slideshowMobileImages.toJS()
          }
          isHome={true}
        >
          <div className="Header__content">
            <span
              dangerouslySetInnerHTML={{
                __html: this.props.currentPage.SlideshowCaption,
              }}
            />
            {this.props.currentPage.SlideshowCaptionTips && (
              <div className="Header__content-tips">
                <span role="img" aria-label="swiss flag">
                  🇨🇭
                </span>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.props.currentPage.SlideshowCaptionTips,
                  }}
                />
              </div>
            )}
          </div>
        </Header>
        <Body {...this.props}>
          <CardAccordion {...this.props} />
          <Card
            screen="mobile"
            title="Communication"
            className="communication short"
          >
            {this.props.currentPage.communication()}
          </Card>
          <CardChronique
            {...this.props}
            title="Chroniques"
            link={chroniquePage.Path}
            chronique={lastChronique}
            className="limited"
          />

          {links.map((link, index) => (
            <Card
              card={link}
              key={link.ID}
              {...this.props}
              className="limited"
            />
          ))}
          <CardContact
            image={this.props.currentPage.contactImage()}
            {...this.props}
          />
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(Home));



// WEBPACK FOOTER //
// ./src/pages/HomePage.js